import z from 'zod';
import { LooseAutocomplete } from '../helpers/type-helpers';

export const UserTypeCodeEnum = z.string();
export type UserTypeCode = LooseAutocomplete<'ADMIN' | 'CLIENTADMIN' | 'CLINICIAN' | 'PATIENT' | 'REFERRER'>;
